export class FailedToUpdateFirstMediaError extends Error {    
    constructor(...params) {
        // @ts-ignore
        super(...params)

        this.name = "FailedToUpdateFirstMediaError"
    }
}